module.exports = __webpack_public_path__ + "media/images/front/robles_concept-c51b1c3e057f2694c9add74b2fc859da.webp";